export type GenomicVariant = {
  rsid: string;
  gene: string;
  variant_tag?: string;
  strand?: string;
  risk_alleles?: string[];
  wild_type?: string;
  interpretation_rule?: string;
  merged_rsids?: string[];
  array_limited?: boolean;
  interpretations?: Record<string, string>;
};

export type GenomicVariantsResponse = { count: number; variants: GenomicVariant[] };

export function filterVariants(list: GenomicVariant[], query: string): GenomicVariant[] {
  const q = query.toLowerCase().trim();
  if (!q) return list;
  return list.filter((v) =>
    v.rsid.toLowerCase().includes(q) ||
    (v.gene || '').toLowerCase().includes(q) ||
    (v.variant_tag || '').toLowerCase().includes(q) ||
    (v.merged_rsids ?? []).some((r) => r.toLowerCase().includes(q)));
}
